(function () {
  'use strict';
  if (window.__srQv) return;
  window.__srQv = true;

  var CFG = window.SR_QV || {};
  var SECTION_ID = CFG.productSectionId || 'main';
  var TRIGGER_SEL = CFG.triggerSelector ||
    '[data-sr-qv-open], [on\\:click="quick-add-component/handleClick"], .quick-add__button--choose';
  var CARD_SEL = CFG.cardSelector || 'product-card, .srp-card, .card, li';
  var LINK_SEL = CFG.linkSelector || '.product-card__link, [ref="productCardLink"], a[href*="/products/"]';

  var modal, dialog, body, lastFocus;

  function ensureModal() {
    if (modal) return modal;
    modal = document.createElement('div');
    modal.id = 'sr-qv';
    modal.setAttribute('role', 'dialog');
    modal.setAttribute('aria-modal', 'true');
    modal.setAttribute('aria-label', 'Vista rápida del producto');
    modal.innerHTML =
      '<div class="sr-qv__overlay" data-sr-qv-overlay></div>' +
      '<div class="sr-qv__dialog" role="document">' +
        '<button type="button" class="sr-qv__close" data-sr-qv-close aria-label="Cerrar">&times;</button>' +
        '<div class="sr-qv__body" data-sr-qv-body><div class="sr-qv__loading"><span class="sr-qv__spinner"></span></div></div>' +
      '</div>';
    document.body.appendChild(modal);
    dialog = modal.querySelector('.sr-qv__dialog');
    body = modal.querySelector('[data-sr-qv-body]');
    modal.addEventListener('click', function (e) {
      if (e.target.closest('[data-sr-qv-overlay]') || e.target.closest('[data-sr-qv-close]')) closeModal();
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && modal.classList.contains('is-open')) closeModal();
    });
    return modal;
  }
  function openModal() {
    ensureModal();
    lastFocus = document.activeElement;
    modal.classList.add('is-open');
    document.documentElement.classList.add('sr-qv-lock');
    document.body.classList.add('sr-qv-lock');
  }
  function closeModal() {
    if (!modal) return;
    modal.classList.remove('is-open');
    document.documentElement.classList.remove('sr-qv-lock');
    document.body.classList.remove('sr-qv-lock');
    if (lastFocus && lastFocus.focus) { try { lastFocus.focus(); } catch (e) {} }
  }

  function cleanUrl(href) {
    if (!href) return '';
    try { return new URL(href, location.origin).pathname; } catch (e) { return href.split('?')[0]; }
  }
  function urlFromCard(node) {
    var card = node.closest(CARD_SEL);
    var link = card && card.querySelector(LINK_SEL);
    if (!link) {
      var p = node;
      while (p && p !== document.body && !link) { link = p.querySelector ? p.querySelector('a[href*="/products/"]') : null; p = p.parentElement; }
    }
    return cleanUrl(link ? link.getAttribute('href') : '');
  }

  var HIDE_SEL = CFG.hideSelectors ||
    '.sr-trev, .sr-benefits, .sr-ben, sr-envio, .sr-envio, .sr-track, .sr-rep, .sr-rb, .divider';

  function trimDetails(wrap) {
    var details = wrap.querySelector('.product-details');
    if (!details) return;
    details.querySelectorAll(HIDE_SEL).forEach(function (el) {
      if (!details.contains(el)) return;
      var parent = el.parentElement;
      var target = parent && parent.classList.contains('shopify-block') && parent.children.length === 1 ? parent : el;
      target.remove();
    });
  }

  function loadProduct(url) {
    body.innerHTML = '<div class="sr-qv__loading"><span class="sr-qv__spinner"></span></div>';
    if (body) body.scrollTop = 0;
    fetch(url, { headers: { 'X-Requested-With': 'XMLHttpRequest' } })
      .then(function (r) { if (!r.ok) throw new Error('HTTP ' + r.status); return r.text(); })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        injectPageStyles(doc);
        var main = doc.getElementById('MainContent') || doc.body;
        var node = main.querySelector('#shopify-section-' + SECTION_ID);
        if (!node) {
          var grid = main.querySelector('.product-information__grid');
          if (grid) node = grid.closest('[id^="shopify-section-"]') || grid.closest('.shopify-section') || grid.closest('section');
        }
        if (!node) {
          var secs = main.querySelectorAll('[id^="shopify-section-"], .shopify-section');
          for (var i = 0; i < secs.length; i++) {
            if (/recommend/i.test(secs[i].id || '')) continue;
            if (secs[i].querySelector('.product-information__grid, product-information, [id^="ProductInfo"]')) { node = secs[i]; break; }
          }
        }
        if (!node) throw new Error('no product section');

        body.innerHTML = '';
        var wrap = document.createElement('div');
        wrap.className = 'sr-qv__native';

        var pb = doc.querySelector('srprofumo-progress-bar');
        if (pb) {
          var pbSec = pb.closest('[id^="shopify-section-"]') || pb;
          var pbWrap = document.createElement('div');
          pbWrap.className = 'sr-qv__pb';
          pbWrap.appendChild(document.importNode(pbSec, true));
          wrap.appendChild(pbWrap);
        }

        wrap.appendChild(document.importNode(node, true));
        trimDetails(wrap);
        body.appendChild(wrap);
        fixLayout(wrap);
        reExecuteScripts(wrap);
        injectPageScripts(doc);
        if (body) body.scrollTop = 0;
      })
      .catch(function () {
        body.innerHTML = '<div class="sr-qv__loading">No se pudo cargar el producto. <a href="' + url + '" style="margin-left:6px">Ver producto &rarr;</a></div>';
      });
  }

  var INJECTED = {};
  function quickHash(str) {
    var h = 0; str = str || '';
    for (var i = 0; i < str.length; i++) { h = (h * 31 + str.charCodeAt(i)) | 0; }
    return str.length + ':' + h;
  }
  function injectPageStyles(doc) {
    var existing = {};
    document.querySelectorAll('style').forEach(function (s) { existing[quickHash(s.textContent)] = true; });

    doc.querySelectorAll('style').forEach(function (s) {
      var key = quickHash(s.textContent);
      if (!s.textContent || existing[key] || INJECTED[key]) return;
      INJECTED[key] = true;
      var st = document.createElement('style');
      st.setAttribute('data-sr-qv-style', '');
      st.textContent = s.textContent;
      document.head.appendChild(st);
    });

    doc.querySelectorAll('link[rel="stylesheet"]').forEach(function (l) {
      var href = l.getAttribute('href');
      if (!href) return;
      var key = 'link:' + href;
      if (INJECTED[key]) return;
      var already = false;
      document.querySelectorAll('link[rel="stylesheet"]').forEach(function (cur) {
        if ((cur.getAttribute('href') || '') === href) already = true;
      });
      if (already) return;
      INJECTED[key] = true;
      var nl = document.createElement('link');
      nl.rel = 'stylesheet';
      nl.href = href;
      nl.setAttribute('data-sr-qv-style', '');
      document.head.appendChild(nl);
    });
  }

  function injectPageScripts(doc) {
    doc.querySelectorAll('script[src]').forEach(function (s) {
      var src = s.getAttribute('src');
      if (!src) return;
      var key = 'src:' + src;
      if (INJECTED[key]) return;
      var exists = false;
      document.querySelectorAll('script[src]').forEach(function (c) { if ((c.getAttribute('src') || '') === src) exists = true; });
      if (exists) return;
      INJECTED[key] = true;
      var ns = document.createElement('script');
      for (var i = 0; i < s.attributes.length; i++) ns.setAttribute(s.attributes[i].name, s.attributes[i].value);
      document.head.appendChild(ns);
    });
    doc.querySelectorAll('script:not([src])').forEach(function (s) {
      var txt = s.textContent || '';
      if (txt.indexOf('customElements.define') === -1) return;
      var key = 'inline:' + quickHash(txt);
      if (INJECTED[key]) return;
      INJECTED[key] = true;
      var ns = document.createElement('script');
      if (s.type) ns.type = s.type;
      ns.textContent = txt;
      document.head.appendChild(ns);
    });
  }

  function reExecuteScripts(container) {
    container.querySelectorAll('script').forEach(function (old) {
      var type = (old.getAttribute('type') || '').toLowerCase();
      if (type === 'application/json' || type === 'application/ld+json') return;
      var s = document.createElement('script');
      for (var i = 0; i < old.attributes.length; i++) s.setAttribute(old.attributes[i].name, old.attributes[i].value);
      s.textContent = old.textContent;
      old.parentNode.replaceChild(s, old);
    });
  }

  function fixLayout(wrap) {
    var two = window.innerWidth > 749;
    var grid = wrap.querySelector('.product-information__grid');
    if (grid) {
      grid.style.setProperty('display', 'grid', 'important');
      grid.style.setProperty('grid-template-columns', two ? 'minmax(0,1fr) minmax(0,1fr)' : '1fr', 'important');
      grid.style.setProperty('gap', two ? '32px' : '18px', 'important');
      grid.style.setProperty('align-items', 'start', 'important');
      grid.style.setProperty('grid-column', 'auto', 'important');
    }
    var media = wrap.querySelector('.product-information__media');
    if (media) { media.style.setProperty('width', '100%', 'important'); media.style.setProperty('min-width', '0', 'important'); media.style.setProperty('order', '0', 'important'); }
    var details = wrap.querySelector('.product-details');
    if (details) { details.style.setProperty('order', '1', 'important'); details.style.setProperty('min-width', '0', 'important'); }
  }

  document.addEventListener('click', function (e) {
    var t = e.target.closest(TRIGGER_SEL);
    if (!t) return;
    var url = t.getAttribute('data-sr-qv-url') || urlFromCard(t);
    if (!url || url.indexOf('/products/') === -1) return;
    e.preventDefault();
    e.stopImmediatePropagation();
    openModal();
    loadProduct(url);
  }, true);

  document.addEventListener('shopify:cart:lines-update', function () {
    if (modal && modal.classList.contains('is-open')) setTimeout(closeModal, 200);
  });

  function disarmNative(scope) {
    var btns = (scope || document).querySelectorAll('[on\\:click="quick-add-component/handleClick"]');
    btns.forEach(function (btn) {
      if (btn.__srqvDisarmed) return;
      btn.__srqvDisarmed = true;
      btn.removeAttribute('on:click');
      btn.setAttribute('data-sr-qv-open', '');
    });
  }
  function startDisarm() {
    disarmNative(document);
    var mo = new MutationObserver(function (muts) {
      for (var i = 0; i < muts.length; i++) {
        if (muts[i].addedNodes && muts[i].addedNodes.length) { disarmNative(document); break; }
      }
    });
    mo.observe(document.body, { childList: true, subtree: true });
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', startDisarm);
  } else {
    startDisarm();
  }
})();